import { create } from 'zustand';

interface UserPresenceState {
  onlineCount: number;
  totalUsers: number;
  setOnlineCount: (count: number) => void;
  setTotalUsers: (count: number) => void;
}

export const useUserPresenceStore = create<UserPresenceState>((set) => ({
  onlineCount: 0,
  totalUsers: 0,
  setOnlineCount: (count) => set({ onlineCount: count }),
  setTotalUsers: (count) => set({ totalUsers: count }),
}));
